import { Route } from '@angular/router';
import { SecureComponent } from './secure.component';
import { authGuard } from '../guards/auth.guard';

export const secureRoutes: Route[] = [
    {
        path: 'secure',
        canActivate: [authGuard],
        component: SecureComponent,
        children: [
            {
                path: 'leave-permission',
                loadComponent: () =>
                    import('./create-leave-permission/create-leave-permission.component').then(
                        (m) => m.CreateLeavePermissionComponent,
                    ),
            },
            {
                path: 'home',
                loadComponent: () =>
                    import('./home/home.component').then(
                        (m) => m.HomeComponent,
                    ),
            },
            {
                path: 'permissions-overview',
                loadComponent: () =>
                    import('./permissions-overview/permissions-overview.component').then(
                        (m) => m.PermissionsOverviewComponent,
                    ),
            },

            //redirection to home after authentication
            {
                path: '**',
                redirectTo: 'home',
            },
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
            },
        ],
    },
];
